<template>
  <div id="app">
    <UploadImages />
    <Gallery />
  </div>
</template>

<script>
import Gallery from './components/Gallery.vue'
import UploadImages from './components/UploadImages.vue'

export default {
  name: 'App',
  components: {
    Gallery,
    UploadImages
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 
}
</style>
